import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f3ed] btw-grain px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#dcd3c6] p-10">
        <p className="btw-overline mb-3">Behind the Love</p>
        <h1 className="font-serif text-3xl mb-1">Editorial sign in</h1>
        <p className="text-sm text-[#5c5852] mb-8">Admin access only.</p>

        <label className="btw-overline block mb-2">Email</label>
        <input
          data-testid="login-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="btw-input mb-6"
        />

        <label className="btw-overline block mb-2">Password</label>
        <input
          data-testid="login-password"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="btw-input mb-8"
        />

        <button type="submit" disabled={busy} data-testid="login-submit" className="btw-btn w-full">
          {busy ? "Signing in…" : "Sign in"}
        </button>

        <p className="text-sm text-black mt-6 text-center">
          <a href="/admin/forgot-password" className="underline underline-offset-4" data-testid="forgot-password-link">
            Forgot password?
          </a>
        </p>
      </form>
    </div>
  );
}
